import React, { Component } from 'react';
import { prettifyDate } from '../../../utils/string';
import { reserveActivityShape } from '../../../utils/propTypes';
import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import './ReserveActivitiesListItem.scss';

export default class ReserveActivities extends Component {
    static propTypes = {
        item: reserveActivityShape.isRequired
    };

    renderDate(date) {
        return date ? prettifyDate(date, { returnDateOnly: true }) : 'No Date';
    }

    renderMerchant(merchantName) {
        return merchantName ? merchantName : 'No Merchant';
    }

    render() {
        const reserveActivity = this.props.item;

        return (
            <div
                className="reserve-activities-list-item"
            >
                <div className="reserve-activities-list-item-left">
                    <span className="reserve-activities-date">
                        {this.renderDate(reserveActivity.reportDate)}
                    </span>
                    <span className="reserve-activities-merchant">
                        {this.renderMerchant(reserveActivity.merchantName)}
                    </span>
                </div>
                <div className="reserve-activities-list-item-right">
                    <span className="reserve-activities-amount">
                        <ColorDollarAmountCell amount={reserveActivity.amount} />
                    </span>
                </div>
            </div>
        );
    }
}
